<p *ngIf="error" role="alert">{{ error }}</p>
<tt-page *ngIf="page">
    <tt-card *ngIf="page.current_user_special_admin === '1'">
        <tt-input ttLabel="searchtext" [ttModel]="page.searchtext" (ttModelChange)="onSearchTextChanged($event)" ttRememberId="w_srusers.searchtext" ttOnlyRemember ttRememberDebounceTime="500" ttShowClearButton [ttClearValue]="''" (keydown.enter)="searchUsers()">
            <ng-container buttons><tt-form-field-button ttIcon="fas fa-search" (ttClick)="searchUsers()" [ttDisabled]="searching"></tt-form-field-button></ng-container>
        </tt-input>
        <tt-checkbox ttLabel="show_deleted_users" [ttModel]="page.show_deleted_users" (ttModelChange)="onDeletedUsersChanged($event)"></tt-checkbox>
        <tt-button ttText="srusers_new" ttIcon="fas fa-plus" (ttClick)="newUser()"></tt-button>
    </tt-card>
    <tt-list [ttData]="items" [ttGoto]="false" (ttClick)="openUser($event)"></tt-list>
</tt-page>
